<template>
  <div id="payment-form--customer">
    <v-layout row wrap>
      <v-flex xs12>
        <h2>Billing Information</h2>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 md6>
        <TextInput
          v-model="value.givenName"
          :validations="{ required: true, min: 2 }"
          display-name="First Name"
          identifier="firstName"
          ref="first-name" />
      </v-flex>

      <v-flex xs12 md6>
        <TextInput
          v-model="value.familyName"
          :validations="{ required: true, min: 2 }"
          display-name="Last Name"
          identifier="lastName"
          ref="last-name" />
      </v-flex>

      <v-flex xs12>
        <TextInput
          v-model="value.email"
          :validations="{ required: true, email: true }"
          display-name="Email"
          identifier="email"
          ref="email" />
      </v-flex>

      <v-flex xs12>
        <TextInput
          v-model="value.address"
          :validations="{ required: true }"
          display-name="Billing Street Address"
          identifier="streetAddress"
          ref="street-address" />
      </v-flex>

      <v-flex xs12 md6>
        <TextInput
          v-model="value.city"
          :validations="{ required: true }"
          display-name="City"
          identifier="city"
          ref="city" />
      </v-flex>

      <v-flex xs12 md3>
        <TextInput
          v-model="value.state"
          :validations="{ max: 3, required: true }"
          display-name="State/Province"
          identifier="state"
          ref="state"
          maxlength="3" />
      </v-flex>

      <v-flex xs12 md3>
        <TextInput
          v-model="value.postalCode"
          :validations="{ required: true }"
          display-name="Zip/Postal Code"
          identifier="postalCode"
          ref="postal-code" />
      </v-flex>

      <v-flex md6 xs12>
        <TextInput
          v-model="value.phone"
          :validations="{ required: true }"
          display-name="Phone Number"
          identifier="phoneNumber"
          mask="###-###-####"
          placeholder="###-###-####"
          ref="phone-number" />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import TextInput from '@/components/Shared/TextInput.vue';

export default {
  components: {
    TextInput,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  inject: ['$validator'],
};
</script>
